var map = {
	"./margins_landscape_large.png": 57322,
	"./margins_landscape_small.png": 72610,
	"./margins_landscape_zero.png": 67553,
	"./margins_portrait_large.png": 51424,
	"./margins_portrait_small.png": 68308,
	"./margins_portrait_zero.png": 62263,
	"./margins_square_large.png": 71944,
	"./margins_square_small.png": 1660,
	"./margins_square_zero.png": 90015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77832;